import { addDays, format, parseISO } from "date-fns";

export const STATUS = {
    COMPLETED: "completed",
    PATCHED: "patched",
    MISSED: "missed",
    IN_PROGRESS: "inProgress",
};

export const STATUS_LABELS = {
    [STATUS.COMPLETED]: "Completed",
    [STATUS.PATCHED]: "Patched",
    [STATUS.MISSED]: "Missed",
    [STATUS.IN_PROGRESS]: "In progress",
};

export const toKey = (date) => format(date, "yyyy-MM-dd");

// Maps every calendar day (yyyy-MM-dd) to the streak period that contains it.
export const buildDayMap = (periods) => {
    const map = new Map();
    periods.forEach((period) => {
        const end = parseISO(period.endDate);
        for (let day = parseISO(period.startDate); day <= end; day = addDays(day, 1)) {
            map.set(toKey(day), period);
        }
    });
    return map;
};

export const describePeriod = (period, cadence) => {
    const start = parseISO(period.startDate);
    const end = parseISO(period.endDate);

    switch (cadence) {
        case "week":
            return `Week of ${format(start, "MMM d")} – ${format(end, "MMM d, yyyy")}`;
        case "month":
            return format(start, "MMMM yyyy");
        default:
            return format(start, "EEEE, MMM d, yyyy");
    }
};

export const extractErrorMessage = (error, fallback) => {
    const data = error?.response?.data;
    if (Array.isArray(data?.errors) && data.errors.length > 0) {
        return data.errors[0]?.errorMessage || data.errors[0]?.ErrorMessage || fallback;
    }
    if (typeof data === "string" && data.trim()) {
        return data;
    }
    return fallback;
};
